export default __webpack_public_path__ + "static/media/13.908d603d.gif";